"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _gameServer = require("../../servers/gameServer");
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * @param {object} props 组件参数
 * @returns
 */
var GameServer = function GameServer(props) {
  // 参数获取
  var gameId = props.gameId,
    setValueFn = props.setValueFn,
    serIptClassName = props.serIptClassName,
    serSelClassName = props.serSelClassName,
    serverlistBorderColor = props.serverlistBorderColor,
    searchListBorderColor = props.searchListBorderColor,
    netNameBG = props.netNameBG,
    netNameColor = props.netNameColor,
    status = props.status,
    selValue = props.selValue,
    getGameList = props.getGameList,
    isWeGame = props.isWeGame,
    hideCode = props.hideCode;
  //存放区服列表数据
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    GSnetList = _useState2[0],
    setGSBetList = _useState2[1];
  //存放输入框value
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    GSinputValue = _useState4[0],
    setGSInputValue = _useState4[1];
  //展示大区列表开关
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showGSList = _useState6[0],
    setShowGSList = _useState6[1];
  //存放当前大区的服务器列表
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    GSserverList = _useState8[0],
    setGSserverList = _useState8[1];
  //当前选中大区索引
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    currentIdx = _useState10[0],
    setcurrentIdx = _useState10[1];
  //存储合成本地搜索数据
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    allServerList = _useState12[0],
    setAllServerList = _useState12[1];
  //展示搜索列表开关
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showSearchList = _useState14[0],
    setShowSearchList = _useState14[1];
  //本地筛选搜索结果
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    searchServerList = _useState16[0],
    setSearchServerList = _useState16[1];
  //存储选中后的名称
  var _useState17 = (0, _react.useState)(''),
    _useState18 = _slicedToArray(_useState17, 2),
    selServerName = _useState18[0],
    setSelServerName = _useState18[1];
  //本地筛选搜索结果
  var _useState19 = (0, _react.useState)(''),
    _useState20 = _slicedToArray(_useState19, 2),
    gameServerErrText = _useState20[0],
    setGameServerErrText = _useState20[1];
  //区分失焦状态
  // const [onBlurType, setOnBlurType] = useState('');
  var onBlurType = '';
  // 加载组件时，只获取一次区服信息
  (0, _react.useEffect)(function () {
    (0, _gameServer.getGameServer)(gameId, status, isWeGame).then(function (res) {
      if (res && res.success) {
        var data = res.data;
        getGameList === null || getGameList === void 0 ? void 0 : getGameList(data);
        var serverArr = data;
        if (hideCode != undefined) {
          serverArr = serverArr.filter(function (item) {
            return item.netTypeCode !== hideCode;
          });
        }
        setGSBetList(serverArr);
        //合并所有服务器列表
        if (data.length > 0) {
          setGSserverList(data[0].serverList);
          setcurrentIdx(data[0].netTypeCode);
          var allListArr = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i].serverList.length > 0) {
              for (var j = 0; j < data[i].serverList.length; j++) {
                if ((selValue === null || selValue === void 0 ? void 0 : selValue.code) === data[i].serverList[j].code || (selValue === null || selValue === void 0 ? void 0 : selValue.serverName) === data[i].serverList[j].serverName) {
                  setGSserverList(data[i].serverList);
                  setcurrentIdx(data[i].netTypeCode);
                }
                allListArr.push(data[i].serverList[j]);
              }
            }
          }
          setAllServerList(allListArr);
        } else {
          setGSserverList([]);
        }
      }
    });
    if (selValue) {
      setGSInputValue(selValue.serverName);
    }
  }, [selValue, gameId]);
  //初始化数据
  var initFn = function initFn() {
    //初始化数据
    setShowGSList(false);
    if (GSnetList.length) {
      setGSserverList(GSnetList[0].serverList);
      setcurrentIdx(GSnetList[0].netTypeCode);
    }
    setGameServerErrText('');
    onBlurType = '';
  };
  //初始化搜索数据
  var initSearchFn = function initSearchFn() {
    setShowSearchList(false);
  };
  //处理搜索结果
  var searchResultsList = function searchResultsList(value) {
    var resultArr = [];
    // 输入框为空不进行搜索
    if (value === '') return;
    allServerList.map(function (ele) {
      if ((ele.serverName + ele.tags).indexOf(value) >= 0) {
        resultArr.push(ele);
      }
    });
    setSearchServerList(resultArr);
  };
  //检查手动输入项，如果存在，替换当前选择，如果不存在，提示错误
  var checkInputValue = function checkInputValue(GSinputValue, searchServerList) {
    //判断输入框内容是否和已选中的区服名称不同，相同不做处理，不同检查是否存在，存在就替换，否则提示'您选择的区服不存在，请重新选择'
    if (GSinputValue != selServerName && selServerName != '' && onBlurType == '') {
      var isSame = false;
      //输入只能匹配到一个结果
      if (searchServerList.length == 1) {
        if (searchServerList[0].serverName == GSinputValue) {
          isSame = true;
          setValueFn({
            code: searchServerList[0].code,
            serverName: searchServerList[0].serverName
          });
        } else {
          isSame = false;
          setValueFn({
            code: '',
            serverName: ''
          });
        }
      } else {
        isSame = false;
        setValueFn({
          code: '',
          serverName: ''
        });
      }
      setGameServerErrText(isSame ? '' : '您选择的区服不存在，请重新选择');
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "SQgameServer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gameServerError"
  }, gameServerErrText), /*#__PURE__*/_react.default.createElement("input", {
    className: !serIptClassName ? 'netTypeNameInput' : serIptClassName,
    placeholder: "\u6C49\u5B57|\u62FC\u97F3|\u5B57\u6BCD",
    maxLength: 20,
    onChange: function onChange(e) {
      var value = e.target.value;
      setGSInputValue(value);
      // 输入搜索项时展示搜索弹层
      setShowSearchList(true);
      //初始化大区弹层(关闭并清空数据)
      initFn();
      //初始化搜索数据
      searchResultsList(value);
    },
    onBlur: function onBlur() {
      //初始化
      setTimeout(function () {
        initSearchFn();
        //检查手动输入项，如果存在，替换当前选择，如果不存在，提示错误
        checkInputValue(GSinputValue, searchServerList);
      }, 500);
    },
    value: GSinputValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: !serSelClassName ? 'netTypeNameSelect' : serSelClassName,
    id: "btn_select_game",
    onClick: function onClick() {
      setShowGSList(!showGSList);
      //关闭时初始展示第一个
      if (showGSList && (GSnetList === null || GSnetList === void 0 ? void 0 : GSnetList[0])) {
        setGSserverList(GSnetList[0].serverList);
        setcurrentIdx(GSnetList[0].netTypeCode);
      } else {
        //打开下拉列表时，关闭搜索列表
        initSearchFn();
      }
    }
  }), showGSList ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      borderColor: serverlistBorderColor
    },
    className: "gameServerlist"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "GSListNetTypeName",
    id: "btn_select_game_type"
  }, GSnetList.map(function (ele, idx) {
    return /*#__PURE__*/_react.default.createElement("li", {
      style: {
        background: netNameBG,
        color: netNameColor
      },
      className: (0, _classnames.default)('GSNetNameItem', {
        on: ele.netTypeCode === currentIdx,
        currentIdx: currentIdx
      }),
      key: idx,
      onClick: function onClick(e) {
        setGSserverList(GSnetList[idx].serverList);
        setcurrentIdx(GSnetList[idx].netTypeCode);
      }
    }, ele.netTypeName);
  })), GSserverList ? /*#__PURE__*/_react.default.createElement("ul", {
    className: "GSListServerName",
    id: "btn_select_game_item"
  }, GSserverList.map(function (ele, idx) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)('GSSerNameItem', {
        select: ele.code === (selValue === null || selValue === void 0 ? void 0 : selValue.code) || ele.serverName === (selValue === null || selValue === void 0 ? void 0 : selValue.serverName)
      }),
      key: idx,
      onClick: function onClick() {
        //赋值给input
        setGSInputValue(ele.serverName);
        //传出参数code
        setValueFn ? setValueFn({
          code: ele.code,
          serverName: ele.serverName
        }) : null;
        //本地存储选中的名称
        setValueFn ? setSelServerName(ele.serverName) : '';
        //初始化数据
        initFn();
      }
    }, ele.serverName);
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "GSclosebtn",
    onClick: function onClick() {
      //初始化数据
      initFn();
    }
  })) : null, showSearchList ? /*#__PURE__*/_react.default.createElement("ul", {
    style: {
      borderColor: searchListBorderColor
    },
    className: "searchList"
  }, searchServerList.map(function (ele, idx) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: idx,
      className: "searchListItem",
      onClick: function onClick() {
        //点击后展示到输入框中
        setGSInputValue(searchServerList[idx].serverName);
        //搜索框点击
        // setOnBlurType('searchSelect');
        onBlurType = 'searchSelect';
        //传出参数code
        setValueFn ? setValueFn({
          code: ele.code,
          serverName: searchServerList[idx].serverName
        }) : null;
        //本地存储选中的名称
        setValueFn ? setSelServerName(ele.serverName) : '';
        //初始化
        initSearchFn();
      }
    }, ele.serverName);
  })) : null);
};
var _default = GameServer;
exports.default = _default;